<app-page-loader *ngIf="isLoading"></app-page-loader>
<div nz-row>
    <div nz-col nzFlex="12" class="my-feedbacks-table">
      <div
      class="table-resposive"
      infiniteScroll
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="10"
      (scrolled)="onScroll($event)"
      [scrollWindow]="false"
      style="max-height:70vh! important;overflow-y: scroll;"
      
      >
        <!-- [nzData]="listOfData" -->
        <nz-table #dataTable [nzData]="feedbackListData"  [nzFrontPagination]="false"
         (nzQueryParams)="sort($event)"  [nzNoResult]="defaultData">
            <thead>
              <tr>
                <th >#Id</th>
                <th   Width="200"  [nzSortFn]="true" nzColumnKey="title_order" nzCustomFilter>Title

                  <nz-filter-trigger [(nzVisible)]="searchFiltervisible"
                      [nzActive]="!FeedbackFilterModel.title" [nzDropdownMenu]="menu">
                        <span nz-icon nzType="search"></span>
                      </nz-filter-trigger>
                </th>
                <th  [nzSortFn]="true" nzColumnKey="date_order">Date </th>
                <!-- <th [nzFilters]="applicationListFilter" [nzFilterFn]="true" (nzFilterChange)="filterFeedback($event, 'app_name')">Application</th > -->
                <th    
                nzCustomFilter >Application
                 <nz-filter-trigger 
                  [nzDropdownMenu]="application">
                   <span nz-icon nzTheme="fill" nzType="filter"></span>
                 </nz-filter-trigger>
                </th>
                <th  nzColumnKey="type_order"  
                [nzFilters]="typeListFilter" [nzFilterFn]="true" (nzFilterChange)="filterFeedback($event, 'type')">Type</th>
                <!-- <th >Rating</th> -->
                <th  [nzSortFn]="true" nzColumnKey="status_order" >Status </th>

                <!-- <th [nzSortFn]="true"  nzColumnKey="assigned_to_order" 
                [nzFilters]="userListFilter" [nzFilterFn]="true" 
                (nzFilterChange)="filterFeedback($event, 'assigned_to')">Assgined To</th> -->
                <th   
                  nzCustomFilter >Assgined To
                   <nz-filter-trigger 
                    [nzDropdownMenu]="assigned">
                     <span nz-icon nzTheme="fill" nzType="filter"></span>
                   </nz-filter-trigger>
                  </th>

                <th >Points
                   
                </th>
                


                  <!-- <th [nzFilters]="filterEmailTypes" [nzFilterFn]="true"  [nzFilters]="userListFilter" [nzFilterFn]="filterFn" (nzFilterChange)="filterFeedback($event, 'submitted_by')">Type</th> -->
                  <th *ngIf="!myFeedbackPage" 
                  nzCustomFilter >Submitted by
                   <nz-filter-trigger 
                    [nzDropdownMenu]="submitted">
                     <span nz-icon nzTheme="fill" nzType="filter"></span>
                   </nz-filter-trigger>
                  </th>

               
                   

              </tr>
            </thead>
            <tbody class="table-body">
              <tr *ngFor="let data of feedbackListData" (click)="goToDetail(data.id)">
                <td >#{{ data.id}}</td>
                <td  Width="200"><strong><span nz-icon nzType="solution" nzTheme="outline"></span> {{data.title ? ( (data.title.length>22)? (data.title | slice:0:22)+'...':(data.title)  ) : 'No Title'}}</strong> </td>
         
                <td> {{ data.created_at | date: 'dd/MM/yyyy'}}</td>
                <td>
                  {{ getAppName(data.application) }}
                 
                
                 </td>
                <td> 

                  <span nz-typography  
                    [ngClass]="getFeedBackType(data.type) == 'Feature' ? 'status-feature':'status-fix'">
                      <span nz-icon nzType="{{getFeedBackType(data.type) == 'Feature' ? 'retweet':'bug'}}" 
                      nzTheme="outline"></span>                
                    {{ getFeedBackType(data.type)}}
                  </span>

                  </td>
                <td> 

                  <nz-badge *ngIf="data.template_data?.status_name ? data.template_data?.status_name : 'NA'"
                  [nzColor]="data.template_data?.status_color"
                  [nzText]="data.template_data?.status_name"
                  ></nz-badge>
                </td>
 
                <!-- <td>
                   
                 <nz-rate [ngModel]="data.rating" nzDisabled></nz-rate>
                </td> -->
               
                <td width="260">
                  <app-user-display
                    *ngIf="data.assigned_user != null; else noFeedbackAssignee"
                    [userId]="getFeedbackAssignedUserId(data)"
                    [userName]="data.template_data.assigned_user_name">
                  </app-user-display>
                  <ng-template #noFeedbackAssignee>NA</ng-template>
                </td>

                <td > 
                  <nz-tag [nzColor]="'lime'">{{ data.point_value ?  data.point_value : 'NA' }}</nz-tag>
                </td>
                <td *ngIf="!myFeedbackPage">
                  <app-user-display
                    [userId]="data.created_by"
                    [userName]="getUserName(data.created_by)">
                  </app-user-display>
                </td>
              </tr>
            </tbody>
          </nz-table>

          <ng-template #defaultData class="tt">
            <p style="display:flex;justify-content: center; align-items:center;font-size:20px;line-height: 1;margin-top:20px;color:rgb(170, 172, 172);">   <span nz-icon nzType="inbox" nzTheme="outline" style="margin-right:10px;font-size: 30px;color:rgb(170, 172, 172);"></span> <span > No Data Found</span> </p>
           </ng-template>
          </div>
          <!-- <nz-dropdown-menu #menu="nzDropdownMenu">
            <div class="ant-table-filter-dropdown">
              <div class="search-box">
                <input type="text" nz-input placeholder="Search name" [(ngModel)]="searchValue" />
                <button nz-button nzSize="small" nzType="primary" (click)="searchEmail()" class="search-button">Search</button>
                <button nz-button nzSize="small" (click)="resetSearchEmail()">Reset</button>
              </div>
            </div>
          </nz-dropdown-menu> -->

    </div>
</div>
<nz-dropdown-menu #submitted="nzDropdownMenu"> 
  <div class="ant-table-filter-dropdown" style="padding:10px">
    <nz-select  nzShowSearch nzPlaceHolder="Submitted by" nzAllowClear [(ngModel)]="submittedBy" (ngModelChange)="filterFeedbackSearch($event, 'submitted_by')">
      <nz-option *ngFor="let option of userListFilter" [nzLabel]="option.text" [nzValue]="option.value"></nz-option>
    </nz-select>
</div>
</nz-dropdown-menu>

<nz-dropdown-menu #assigned="nzDropdownMenu"> 
  <div class="ant-table-filter-dropdown" style="padding:10px">
    <nz-select  nzShowSearch nzPlaceHolder="Assigned to" nzAllowClear [(ngModel)]="assignedTo" (ngModelChange)="filterFeedbackSearch($event, 'assigned_to')">
      <nz-option *ngFor="let option of userListFilter" [nzLabel]="option.text" [nzValue]="option.value"></nz-option>
    </nz-select>
</div>
</nz-dropdown-menu>

<nz-dropdown-menu #application="nzDropdownMenu"> 
  <div class="ant-table-filter-dropdown" style="padding:10px">
    <nz-select  nzShowSearch nzPlaceHolder="Application" nzAllowClear [(ngModel)]="applicationFilter" (ngModelChange)="filterFeedbackSearch($event, 'app_name')">
      <nz-option *ngFor="let option of applicationListFilter" [nzLabel]="option.text" [nzValue]="option.value"></nz-option>
    </nz-select>
</div>
</nz-dropdown-menu>

<nz-dropdown-menu #menu="nzDropdownMenu">
    <div class="ant-table-filter-dropdown">
      <div class="search-box">
        <input type="text" nz-input placeholder="Search Title"
        [(ngModel)]="FeedbackFilterModel.title"
        (keyup)="inputkeyUp()"
        (keydown)="inputKeyDown()"
         />
        <!-- <button nz-button nzSize="small" nzType="primary" (click)="search()" class="search-button">Search</button> -->
        <button nz-button nzSize="small" (click)="FeedbackFilterModel.title = null; getFeedbacks();searchFiltervisible = false">Reset</button>
      </div>
    </div>
  </nz-dropdown-menu>
